import { Button, Text } from "@src/straps/base";
import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex flex-col items-center gap-5">
        <div className="mb-2">
          <NotFoundIcon />
        </div>
        <Text variant="h2_t-30-700">Page not found.</Text>
        <Text variant="sb_t-14-500">
          Please contact Backpack Support if the problem persists.
        </Text>
        <Button
          component={Link}
          to="/"
          width="200px"
          dataTestId="go-home-link-button"
        >
          Go home
        </Button>
      </div>
    </div>
  );
}

function NotFoundIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101"
      height="102"
      viewBox="0 0 101 102"
      fill="none"
    >
      <path
        d="M10.0254 11.6685H71.6043C82.65 11.6685 91.6043 20.6228 91.6043 31.6685V73.2474C91.6043 84.2931 82.65 93.2474 71.6043 93.2474H30.0254C18.9797 93.2474 10.0254 84.2931 10.0254 73.2474V11.6685Z"
        fill="#BBEBE7"
        stroke="#00A091"
        strokeWidth="2"
      />
      <path
        d="M53.8125 90.1816L53.8125 97.8119C53.8125 99.1083 52.7572 100.16 51.4569 100.16L46.1568 100.16C44.8566 100.16 43.8013 99.1083 43.8013 97.8119L43.8013 92.5301C43.8013 91.2338 44.8566 90.1816 46.1568 90.1816L53.8125 90.1816Z"
        fill="#E8F2E6"
        stroke="#999999"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M50.5994 3.68506H70.2708V11.3159C70.2708 12.6119 69.2165 13.6638 67.9175 13.6638H50.5994C49.3004 13.6638 48.2461 12.6119 48.2461 11.3159V6.033C48.2461 4.73694 49.3004 3.68506 50.5994 3.68506Z"
        fill="#E8F2E6"
        stroke="#999999"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M87.1053 11.5039V4.22013C87.1053 2.92553 86.0565 1.87695 84.7615 1.87695H77.1465V21.4636C77.1465 22.7582 78.1965 23.8068 79.4903 23.8068H96.7325C98.0263 23.8068 99.0763 22.757 99.0763 21.4624V16.1903C99.0763 14.8957 98.0275 13.8471 96.7325 13.8471H89.4491C88.1553 13.8471 87.1053 12.7985 87.1053 11.5039Z"
        fill="#E8F2E6"
        stroke="#999999"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.5347 100.159L36.793 100.159L36.793 92.5356C36.793 91.2406 35.7092 90.1895 34.371 90.1895L26.8412 90.1895C25.5031 90.1895 24.4193 89.1397 24.4193 87.8435L24.4193 80.5531C24.4193 79.2581 23.3355 78.207 21.9974 78.207L4.17555 78.207C2.83743 78.207 1.75362 79.2581 1.75362 80.5543L1.75362 85.8317C1.75362 87.1267 2.83743 88.1778 4.17555 88.1778L11.7041 88.1778C13.0423 88.1778 14.1261 89.2276 14.1261 90.5238L14.1128 97.8095C14.1103 99.1069 15.1954 100.16 16.5347 100.16L16.5347 100.159Z"
        fill="#E8F2E6"
        stroke="#999999"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19 60.6154H29.6256V63.5385V64.5385H30.6256H34.0877H35.0877V63.5385V60.6154H36.4953H37.4953V59.6154V56.3956V55.3956H36.4953H35.0877V49.9231V48.9231H34.0877H30.6256H29.6256V49.9231V55.3956H24.3544L31.1366 40.885L31.8019 39.4615H30.2307H26.4796H25.8444L25.5744 40.0366L18.0948 55.9707L18 56.1726V56.3956V59.6154V60.6154H19ZM43.4633 61.3163L43.4682 61.3232L43.4731 61.3299C45.2752 63.7727 47.7949 65 50.8908 65C54.0147 65 56.5406 63.7753 58.3141 61.3221L58.3182 61.3163C60.0443 58.8926 60.8792 55.7704 60.8792 52C60.8792 48.2333 60.0458 45.108 58.3163 42.7139C56.5429 40.2254 54.0152 39 50.8908 39C47.7933 39 45.271 40.2289 43.4689 42.7088L43.4675 42.7108C41.7364 45.1053 40.9024 48.2317 40.9024 52C40.9024 55.7704 41.7373 58.8926 43.4633 61.3163ZM70.8591 55.3956L77.6413 40.885L78.3066 39.4615H76.7354H72.9843H72.3491L72.0791 40.0366L64.5995 55.9707L64.5047 56.1726V56.3956V59.6154V60.6154H65.5047H76.1303V63.5385V64.5385H77.1303H80.5924H81.5924V63.5385V60.6154H83H84V59.6154V56.3956V55.3956H83H81.5924V49.9231V48.9231H80.5924H77.1303H76.1303V49.9231V55.3956H70.8591ZM50.8908 45.4176C52.0225 45.4176 52.8507 45.8926 53.4497 46.8839C54.0886 47.9413 54.4813 49.6253 54.4813 52C54.4813 54.3572 54.0889 56.0328 53.4504 57.086C52.8515 58.0739 52.023 58.5494 50.8908 58.5494C49.7556 58.5494 48.9379 58.0797 48.3488 57.1011C47.718 56.0531 47.3324 54.3779 47.3324 52C47.3324 49.6224 47.7179 47.9375 48.3503 46.88C48.9418 45.8909 49.7607 45.4176 50.8908 45.4176Z"
        fill="white"
        stroke="#00A091"
        strokeWidth="2"
      />
    </svg>
  );
}
